/**
 *
 * 第三方合作标准模式
 *
 */

import { getUrlParam, getUserInfo } from '@/utils/api';

const comein_channel = 'normal';
const urlParam = getUrlParam();
const userInfo = getUserInfo();

export const isThirdParty =
	urlParam.comein_channel === comein_channel || Boolean(urlParam.channel && urlParam.userInfo);

function Bridge() {
	this.authMethod = 0;

	this.comein_channel = comein_channel;

	this.uc = urlParam.channel || (userInfo && userInfo.uc) || '';

	this.showMenu = false;
}

Bridge.prototype.joinEventFail = function () {
	this.$router.replace({ name: '404', query: { auth: 0 } });
};

export default Bridge;
